<div #inputElement class="input-wrapper desktop" (click)="onInputClick()">
  <ng-container
    *ngTemplateOutlet="
      inputsTemplate;
      context: {
        from: formControl.value?.from,
        to: formControl.value?.to,
        onFromChanged: onFromChanged.bind(this),
        onToChanged: onToChanged.bind(this),
        onBlur: onInputBlur.bind(this),
        labelClass: 'text-jazlyn-700',
        fromError: fromErrorMessage,
        toError: toErrorMessage,
      }
    "
  />
</div>

<div class="d-flex d-md-none input-wrapper" (click)="$event.preventDefault(); showMobileModal()">
  <ng-container
    *ngTemplateOutlet="
      inputsTemplate;
      context: {
        from: formControl.value?.from,
        to: formControl.value?.to,
        labelClass: 'text-jazlyn-700',
        fromError: fromErrorMessage,
        toError: toErrorMessage,
        onBlur: onInputBlur.bind(this),
      }
    "
  />
</div>

<ng-template
  #inputsTemplate
  let-from="from"
  let-to="to"
  let-onFromChanged="onFromChanged"
  let-onToChanged="onToChanged"
  let-onBlur="onBlur"
  let-labelClass="labelClass"
  let-fromError="fromError"
  let-toError="toError"
>
  <div class="g-4 d-flex w-100">
    <div class="w-100">
      <ds-input
        [attr.data-id]="range.From"
        [value]="from ?? ''"
        [placeholder]="props.placeholderFrom"
        [disabled]="formControl.disabled"
        [label]="props.labelFrom"
        [error]="fromError || undefined"
        autocomplete="off"
        data-id="range-picker-from-input"
        (blurred)="onBlur ? onBlur() : null"
        (valueChange)="onFromChanged ? onFromChanged($event) : null"
      />
    </div>

    <div class="w-100">
      <ds-input
        [attr.data-id]="range.To"
        [value]="to ?? ''"
        [placeholder]="props.placeholderTo"
        [disabled]="formControl.disabled"
        [label]="props.labelTo"
        [error]="toError || undefined"
        autocomplete="off"
        data-id="range-picker-to-input"
        (blurred)="onBlur ? onBlur() : null"
        (valueChange)="onToChanged ? onToChanged($event) : null"
      />
    </div>
  </div>
</ng-template>

<ng-template #dropdownTemplate>
  <div id="range-picker" [style.height]="overlayModalHeight" class="range-picker">
    <div>
      <range-picker
        [selectedValue]="currentSelectedValues"
        (close)="closeDropdown()"
        (setDates)="onSetDates($event)"
        (nextMothClick)="runIsInViewportCheck()"
        (prevMothClick)="runIsInViewportCheck()"
      />
    </div>
  </div>
</ng-template>

<ng-template #mobileTemplate>
  <div class="d-flex flex-column range-picker-mobile h-100">
    <div class="d-flex justify-content-between align-items-center pt-5 pl-4 pr-4">
      <h2 class="semi-bold">Select date range</h2>
      <div class="cursor-pointer" (click)="hideMobileModal()">
        <img
          width="12"
          height="12"
          data-id="close-mobile"
          src="assets/icons/close_blue.svg"
          alt="close"
        />
      </div>
    </div>
    <div class="d-flex pl-4 pr-4">
      <ng-container
        *ngTemplateOutlet="
          inputsTemplate;
          context: {
            from: currentMobileSelectedValues[0],
            to: currentMobileSelectedValues[1],
            onFromChanged: onMobileFromChanged.bind(this),
            onToChanged: onMobileToChanged.bind(this),
            onBlur: onMobileInputBlur.bind(this),
            labelClass: 'caption semi-bold',
          }
        "
      />
    </div>
    <div class="h-100 overflow-y">
      <range-picker
        [selectedValue]="currentMobileSelectedValues"
        (changeSelect)="onSelectDatesMobile($event)"
        (close)="hideMobileModal()"
        (setDates)="onSetDates($event); hideMobileModal()"
      />
    </div>
  </div>
</ng-template>
